import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/magnify.svg'


const _withScopeId = n => (_pushScopeId("data-v-82922c78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component pageList" }
const _hoisted_2 = { class: "top-box" }
const _hoisted_3 = { class: "left-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title__text" }, "환자 리스트", -1))
const _hoisted_5 = { class: "right-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12C6 11 6.25 10.03 6.7 9.2L5.24 7.74C4.46 8.97 4 10.43 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V23L16 19L12 15M12 4V1L8 5L12 9V6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12C18 13 17.75 13.97 17.3 14.8L18.76 16.26C19.54 15.03 20 13.57 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4Z",
    fill: "white"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "동기화", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "search-box focusable" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_11 = { class: "table__box" }
const _hoisted_12 = { class: "table__header" }
const _hoisted_13 = { style: {"flex-basis":"11.5%"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "중환자실", -1))
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<mask id=\"mask0_1571_19983\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" data-v-82922c78><rect width=\"24\" height=\"24\" fill=\"#D9D9D9\" data-v-82922c78></rect></mask><g mask=\"url(#mask0_1571_19983)\" data-v-82922c78><path d=\"M12 5L7 10H17L12 5Z\" fill=\"#888AA5\" class=\"sort-top\" data-v-82922c78></path><path d=\"M12 20L7 15H17L12 20Z\" fill=\"#888AA5\" class=\"sort-bottom\" data-v-82922c78></path></g>", 2)
const _hoisted_17 = [
  _hoisted_15
]
const _hoisted_18 = { style: {"flex-basis":"11.5%"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "환자번호", -1))
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<mask id=\"mask0_1571_19983\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" data-v-82922c78><rect width=\"24\" height=\"24\" fill=\"#D9D9D9\" data-v-82922c78></rect></mask><g mask=\"url(#mask0_1571_19983)\" data-v-82922c78><path d=\"M12 5L7 10H17L12 5Z\" fill=\"#888AA5\" class=\"sort-top\" data-v-82922c78></path><path d=\"M12 20L7 15H17L12 20Z\" fill=\"#888AA5\" class=\"sort-bottom\" data-v-82922c78></path></g>", 2)
const _hoisted_22 = [
  _hoisted_20
]
const _hoisted_23 = { style: {"flex-basis":"9%"} }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "이름", -1))
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<mask id=\"mask0_1571_19983\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" data-v-82922c78><rect width=\"24\" height=\"24\" fill=\"#D9D9D9\" data-v-82922c78></rect></mask><g mask=\"url(#mask0_1571_19983)\" data-v-82922c78><path d=\"M12 5L7 10H17L12 5Z\" fill=\"#888AA5\" class=\"sort-top\" data-v-82922c78></path><path d=\"M12 20L7 15H17L12 20Z\" fill=\"#888AA5\" class=\"sort-bottom\" data-v-82922c78></path></g>", 2)
const _hoisted_27 = [
  _hoisted_25
]
const _hoisted_28 = { style: {"flex-basis":"9%"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "나이", -1))
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<mask id=\"mask0_1571_19983\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" data-v-82922c78><rect width=\"24\" height=\"24\" fill=\"#D9D9D9\" data-v-82922c78></rect></mask><g mask=\"url(#mask0_1571_19983)\" data-v-82922c78><path d=\"M12 5L7 10H17L12 5Z\" fill=\"#888AA5\" class=\"sort-top\" data-v-82922c78></path><path d=\"M12 20L7 15H17L12 20Z\" fill=\"#888AA5\" class=\"sort-bottom\" data-v-82922c78></path></g>", 2)
const _hoisted_32 = [
  _hoisted_30
]
const _hoisted_33 = { style: {"flex-basis":"9%"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "성별", -1))
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<mask id=\"mask0_1571_19983\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" data-v-82922c78><rect width=\"24\" height=\"24\" fill=\"#D9D9D9\" data-v-82922c78></rect></mask><g mask=\"url(#mask0_1571_19983)\" data-v-82922c78><path d=\"M12 5L7 10H17L12 5Z\" fill=\"#888AA5\" class=\"sort-top\" data-v-82922c78></path><path d=\"M12 20L7 15H17L12 20Z\" fill=\"#888AA5\" class=\"sort-bottom\" data-v-82922c78></path></g>", 2)
const _hoisted_37 = [
  _hoisted_35
]
const _hoisted_38 = { style: {"flex-basis":"12.5%"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "최근 TDM 검사 일자", -1))
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<mask id=\"mask0_1571_19983\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" data-v-82922c78><rect width=\"24\" height=\"24\" fill=\"#D9D9D9\" data-v-82922c78></rect></mask><g mask=\"url(#mask0_1571_19983)\" data-v-82922c78><path d=\"M12 5L7 10H17L12 5Z\" fill=\"#888AA5\" class=\"sort-top\" data-v-82922c78></path><path d=\"M12 20L7 15H17L12 20Z\" fill=\"#888AA5\" class=\"sort-bottom\" data-v-82922c78></path></g>", 2)
const _hoisted_42 = [
  _hoisted_40
]
const _hoisted_43 = { style: {"flex-basis":"12.5%"} }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "최근 TDM 검사 수치", -1))
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<mask id=\"mask0_1571_19983\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" data-v-82922c78><rect width=\"24\" height=\"24\" fill=\"#D9D9D9\" data-v-82922c78></rect></mask><g mask=\"url(#mask0_1571_19983)\" data-v-82922c78><path d=\"M12 5L7 10H17L12 5Z\" fill=\"#888AA5\" class=\"sort-top\" data-v-82922c78></path><path d=\"M12 20L7 15H17L12 20Z\" fill=\"#888AA5\" class=\"sort-bottom\" data-v-82922c78></path></g>", 2)
const _hoisted_47 = [
  _hoisted_45
]
const _hoisted_48 = { style: {"flex-basis":"12.5%"} }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "최근 크레아티닌 검사 일자", -1))
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<mask id=\"mask0_1571_19983\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" data-v-82922c78><rect width=\"24\" height=\"24\" fill=\"#D9D9D9\" data-v-82922c78></rect></mask><g mask=\"url(#mask0_1571_19983)\" data-v-82922c78><path d=\"M12 5L7 10H17L12 5Z\" fill=\"#888AA5\" class=\"sort-top\" data-v-82922c78></path><path d=\"M12 20L7 15H17L12 20Z\" fill=\"#888AA5\" class=\"sort-bottom\" data-v-82922c78></path></g>", 2)
const _hoisted_52 = [
  _hoisted_50
]
const _hoisted_53 = { style: {"flex-basis":"12.5%"} }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "최근 크레아티닌 검사 수치", -1))
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<mask id=\"mask0_1571_19983\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" data-v-82922c78><rect width=\"24\" height=\"24\" fill=\"#D9D9D9\" data-v-82922c78></rect></mask><g mask=\"url(#mask0_1571_19983)\" data-v-82922c78><path d=\"M12 5L7 10H17L12 5Z\" fill=\"#888AA5\" class=\"sort-top\" data-v-82922c78></path><path d=\"M12 20L7 15H17L12 20Z\" fill=\"#888AA5\" class=\"sort-bottom\" data-v-82922c78></path></g>", 2)
const _hoisted_57 = [
  _hoisted_55
]
const _hoisted_58 = { class: "table__body" }
const _hoisted_59 = { class: "no_data" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { style: {"flex-basis":"11.5%"} }
const _hoisted_62 = {
  key: 0,
  class: "caution-box"
}
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<svg class=\"icon\" width=\"22\" height=\"22\" viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-82922c78><mask id=\"mask0_1059_1095\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"22\" height=\"22\" data-v-82922c78><rect width=\"22\" height=\"22\" fill=\"#D9D9D9\" data-v-82922c78></rect></mask><g mask=\"url(#mask0_1059_1095)\" data-v-82922c78><path d=\"M11 15.5833C11.2598 15.5833 11.4775 15.4954 11.6532 15.3197C11.8289 15.144 11.9167 14.9263 11.9167 14.6666C11.9167 14.4069 11.8289 14.1892 11.6532 14.0135C11.4775 13.8378 11.2598 13.7499 11 13.7499C10.7403 13.7499 10.5226 13.8378 10.3469 14.0135C10.1712 14.1892 10.0834 14.4069 10.0834 14.6666C10.0834 14.9263 10.1712 15.144 10.3469 15.3197C10.5226 15.4954 10.7403 15.5833 11 15.5833ZM10.0834 11.9166H11.9167V6.41658H10.0834V11.9166ZM11 20.1666C9.73198 20.1666 8.54032 19.926 7.42504 19.4447C6.30976 18.9635 5.33962 18.3103 4.51462 17.4853C3.68962 16.6603 3.0365 15.6902 2.55525 14.5749C2.074 13.4596 1.83337 12.268 1.83337 10.9999C1.83337 9.73186 2.074 8.5402 2.55525 7.42492C3.0365 6.30964 3.68962 5.3395 4.51462 4.5145C5.33962 3.6895 6.30976 3.03638 7.42504 2.55513C8.54032 2.07388 9.73198 1.83325 11 1.83325C12.2681 1.83325 13.4598 2.07388 14.575 2.55513C15.6903 3.03638 16.6605 3.6895 17.4855 4.5145C18.3105 5.3395 18.9636 6.30964 19.4448 7.42492C19.9261 8.5402 20.1667 9.73186 20.1667 10.9999C20.1667 12.268 19.9261 13.4596 19.4448 14.5749C18.9636 15.6902 18.3105 16.6603 17.4855 17.4853C16.6605 18.3103 15.6903 18.9635 14.575 19.4447C13.4598 19.926 12.2681 20.1666 11 20.1666ZM11 18.3333C13.0473 18.3333 14.7813 17.6228 16.2021 16.202C17.623 14.7812 18.3334 13.0471 18.3334 10.9999C18.3334 8.9527 17.623 7.21867 16.2021 5.79784C14.7813 4.377 13.0473 3.66659 11 3.66659C8.95282 3.66659 7.21879 4.377 5.79796 5.79784C4.37712 7.21867 3.66671 8.9527 3.66671 10.9999C3.66671 13.0471 4.37712 14.7812 5.79796 16.202C7.21879 17.6228 8.95282 18.3333 11 18.3333Z\" fill=\"#888AA5\" data-v-82922c78></path></g></svg><div class=\"blue__box message\" data-v-82922c78>해당 환자는 TDM 검사 기록이 없는 환자입니다.</div>", 2)
const _hoisted_65 = [
  _hoisted_63
]
const _hoisted_66 = { style: {"flex-basis":"11.5%"} }
const _hoisted_67 = { style: {"flex-basis":"9%"} }
const _hoisted_68 = { style: {"flex-basis":"9%"} }
const _hoisted_69 = { style: {"flex-basis":"9%"} }
const _hoisted_70 = { style: {"flex-basis":"12.5%"} }
const _hoisted_71 = { style: {"flex-basis":"12.5%"} }
const _hoisted_72 = { style: {"flex-basis":"12.5%"} }
const _hoisted_73 = { style: {"flex-basis":"12.5%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ICUBox = _resolveComponent("ICUBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_ICUBox)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "sync_btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.syncData()))
        }, _hoisted_8),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "input__box",
            placeholder: "환자번호 또는 이름을 검색하세요.",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchText) = $event)),
            onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchPatient())),
            spellcheck: "false"
          }, null, 544), [
            [_vModelText, _ctx.searchText]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["sort-icon", {'sort-desc':_ctx.currSort=='unitDesc', 'sort-asc':_ctx.currSort=='unitAsc'}]),
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortPatient('unit')))
          }, _hoisted_17, 2))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["sort-icon", {'sort-desc':_ctx.currSort=='numberDesc', 'sort-asc':_ctx.currSort=='numberAsc'}]),
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortPatient('number')))
          }, _hoisted_22, 2))
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["sort-icon", {'sort-desc':_ctx.currSort=='nameDesc', 'sort-asc':_ctx.currSort=='nameAsc'}]),
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortPatient('name')))
          }, _hoisted_27, 2))
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["sort-icon", {'sort-desc':_ctx.currSort=='ageDesc', 'sort-asc':_ctx.currSort=='ageAsc'}]),
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortPatient('age')))
          }, _hoisted_32, 2))
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["sort-icon", {'sort-desc':_ctx.currSort=='genderDesc', 'sort-asc':_ctx.currSort=='genderAsc'}]),
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortPatient('gender')))
          }, _hoisted_37, 2))
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["sort-icon", {'sort-desc':_ctx.currSort=='tdmDateDesc', 'sort-asc':_ctx.currSort=='tdmDateAsc'}]),
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortPatient('tdmDate')))
          }, _hoisted_42, 2))
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["sort-icon", {'sort-desc':_ctx.currSort=='tdmCountDesc', 'sort-asc':_ctx.currSort=='tdmCountAsc'}]),
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortPatient('tdmCount')))
          }, _hoisted_47, 2))
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["sort-icon", {'sort-desc':_ctx.currSort=='crDateDesc', 'sort-asc':_ctx.currSort=='crDateAsc'}]),
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortPatient('crDate')))
          }, _hoisted_52, 2))
        ]),
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["sort-icon", {'sort-desc':_ctx.currSort=='crCountDesc', 'sort-asc':_ctx.currSort=='crCountAsc'}]),
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortPatient('crCount')))
          }, _hoisted_57, 2))
        ])
      ]),
      _createElementVNode("div", _hoisted_58, [
        _withDirectives(_createElementVNode("div", _hoisted_59, "검색 결과가 존재하지 않습니다.", 512), [
          [_vShow, _ctx.pageList.length==0]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageList, (patient) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: patient.PT_NO,
            class: _normalizeClass(["table__tr", {'caution': patient.CREATININE.length==0}]),
            onClick: ($event: any) => (_ctx.setPatientData(patient))
          }, [
            _createElementVNode("div", _hoisted_61, [
              (patient.CREATININE.length==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_65))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(patient.WD_DEPT_CD), 1)
            ]),
            _createElementVNode("div", _hoisted_66, _toDisplayString(patient.PT_NO), 1),
            _createElementVNode("div", _hoisted_67, _toDisplayString(patient.PT_NM), 1),
            _createElementVNode("div", _hoisted_68, _toDisplayString(patient.AGE), 1),
            _createElementVNode("div", _hoisted_69, _toDisplayString(patient.SEX_TP_CD), 1),
            _createElementVNode("div", _hoisted_70, [
              (patient.VNC.length>0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.moment(new Date(patient.VNC[patient.VNC.length-1].VNC_DTE)).format('YYYY-MM-DD HH:mm')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("-")
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_71, [
              (patient.VNC.length>0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(patient.VNC[patient.VNC.length-1].VNC_RSLT), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("-")
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_72, [
              (patient.CREATININE.length>0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.moment(new Date(patient.CREATININE[patient.CREATININE.length-1].CREATININE_DTE)).format('YYYY-MM-DD HH:mm')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("-")
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_73, [
              (patient.CREATININE.length>0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(patient.CREATININE[patient.CREATININE.length-1].CREATININE_RSLT), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("-")
                  ], 64))
            ])
          ], 10, _hoisted_60)), [
            [_vShow, _ctx.pageList.length>0]
          ])
        }), 128))
      ])
    ])
  ]))
}